import React from "react";
import http from "../../Api/http";
import Checkbox from "../../Components/Checkbox";

const $ = window.$;

export default class PrintOverTime extends React.Component {

    constructor(props) {
        super(props);
        this.hash = null
        this.state = {
            loading: true,
            dataObject: undefined,
            isDesktop: window.innerWidth > 800
        }
    }

    updatePredicate = () => {
        this.setState({ isDesktop: window.innerWidth > 800 });
    }

    componentDidMount = async () => {
        document.addEventListener("resize", this.updatePredicate);
        let _dataObject = await this.getData();
        if (_dataObject) {
            this.setState({ dataObject: _dataObject, loading: false }, () => {
                setTimeout(() => {
                    this.doPrint();
                }, 10);
            })
        }
        else {
            this.setState({ loading: false })
        }
    }

    render() {

        return this.state.dataObject ?
            (
                <div id="divMain" style={{ direction: $.strings.dir, padding: '2em' }}>
                    <div className="p-grid">
                        <div className="p-col-6 p-xl-6 p-lg-6 p-md-6 p-sm-6" style={{ textAlign: 'center' }}>
                            <br />
                            <div style={{ fontSize: '16px', fontWeight: 'bold' }}>{this.state.dataObject.companyName}</div>
                            <br />
                            <div style={{ fontSize: '16px', fontWeight: 'bold' }}>{this.state.dataObject.companyAddress}</div>
                        </div>
                        <div className="p-col-6 p-xl-6 p-lg-6 p-md-6 p-sm-6" style={{ textAlign: $.strings.dir === 'rtl' ? 'left' : 'right' }}>
                            <img src="../../assets/layout/images/printlogo.png" alt="logo" />
                        </div>
                        <div className="p-col-12 p-xl-12 p-lg-12 p-md-12 p-sm-12">
                            <hr />
                        </div>
                        <div className="p-col-12 p-xl-12 p-lg-12 p-md-12 p-sm-12">
                            <div style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '5px', textAlign: 'center' }}>{$.strings.printVacation.overTimeRequest}</div>
                            <br />
                        </div>
                    </div>

                    {/* خاص بالموظف */}
                    <div className="p-grid" style={{ border: '1px solid gray', fontSize: '16px', fontWeight: 'bold' }}>
                        <div className="p-col-12 p-xl-12 p-lg-12 p-md-12 p-sm-12" style={{ background: 'lightgray' }}>
                            {$.strings.printVacation.specialForEmployee}
                        </div>
                        {/* الموظف */}
                        <div className="p-col-6 p-xl-6 p-lg-6 p-md-6 p-sm-6">
                            {$.strings.printVacation.empName + ": "}<span style={{ borderBottom: '1px dashed black' }}>{this.state.dataObject.empName}</span>
                        </div>

                        {/* القسم */}
                        <div className="p-col-6 p-xl-6 p-lg-6 p-md-6 p-sm-6" style={{ textAlign: $.strings.dir === "rtl" ? 'left' : 'right' }}>
                            {$.strings.printVacation.section + ": "}<span style={{ borderBottom: '1px dashed black' }}>{this.state.dataObject.sectionName}</span>
                        </div>

                        {/* تاريخ العمل الاضافي */}
                        <div className="p-col-12 p-xl-12 p-lg-12 p-md-12 p-sm-12">
                            {$.strings.printVacation.overTimeDate + ": "}<span style={{ borderBottom: '1px dashed black' }}>{this.state.dataObject.fromDate}</span>
                        </div>

                        {/* الفترة المطلوبة للعمل الاضافي */}
                        <div className="p-col-12 p-xl-12 p-lg-12 p-md-12 p-sm-12" >
                            <div style={{ display: 'flex' }}>
                                {$.strings.printVacation.overTimePeriod + ": "}
                                &nbsp;
                                <table style={{ border: '1px solid black', borderCollapse: 'collapse', textAlign: 'center' }}>
                                    <tr>
                                        <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{$.strings.printVacation.minutes}</td>
                                        <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{$.strings.printVacation.hours}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {
                                                this.state.dataObject.totalTime ? this.state.dataObject.totalTime.split(':')[1] : '00'
                                            }
                                        </td>
                                        <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {
                                                this.state.dataObject.totalTime ? this.state.dataObject.totalTime.split(':')[0] : '00'
                                            }
                                        </td>
                                    </tr>
                                </table>
                                &nbsp;
                                <span> {$.strings.printVacation.approximately} </span>
                            </div>
                        </div>
                        {/* من ساعة الى ساعة */}
                        <div className="p-col-12 p-xl-12 p-lg-12 p-md-12 p-sm-12" >
                            <div style={{ display: 'flex' }}>
                                {$.strings.printVacation.fromHour + ": "}
                                &nbsp; &nbsp;
                                <table style={{ border: '1px solid black', borderCollapse: 'collapse', textAlign: 'center' }}>
                                    <tr>
                                        <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{$.strings.printVacation.minutes}</td>
                                        <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{$.strings.printVacation.hours}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {
                                                this.state.dataObject.fromTime ? this.state.dataObject.fromTime.split(':')[1] : '00'
                                            }
                                        </td>
                                        <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {
                                                this.state.dataObject.fromTime ? this.state.dataObject.fromTime.split(':')[0] : '00'
                                            }
                                        </td>
                                    </tr>
                                </table>
                                &nbsp; &nbsp;
                                <span> {$.strings.printVacation.toHour + ": "} </span>
                                &nbsp; &nbsp;
                                <table style={{ border: '1px solid black', borderCollapse: 'collapse', textAlign: 'center' }}>
                                    <tr>
                                        <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{$.strings.printVacation.minutes}</td>
                                        <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{$.strings.printVacation.hours}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {
                                                this.state.dataObject.toTime ? this.state.dataObject.toTime.split(':')[1] : '00'
                                            }
                                        </td>
                                        <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {
                                                this.state.dataObject.toTime ? this.state.dataObject.toTime.split(':')[0] : '00'
                                            }
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <div className="p-col-12 p-xl-12 p-lg-12 p-md-12 p-sm-12">
                            <br />
                        </div>

                        {/* أغراض العمل الإضافي */}
                        <div className="p-col-12 p-xl-12 p-lg-12 p-md-12 p-sm-12">
                            <span style={{ fontWeight: 'bold' }}>{$.strings.printVacation.overTimeReason + ": "}</span>
                            <span style={{ borderBottom: '1px dashed black' }}>{this.state.dataObject.requestNote}</span>
                        </div>

                        {/* توقيع الموظف */}
                        <div className="p-col-2 p-xl-2 p-lg-2 p-md-2 p-sm-2">
                            {$.strings.printVacation.empSign + ": "}
                        </div>
                        <div className="p-col-6 p-xl-6 p-lg-6 p-md-6 p-sm-6">
                            <span >-------------------------------------</span>
                        </div>

                        {/* التاريخ */}
                        <div className="p-col-4 p-xl-4 p-lg-4 p-md-4 p-sm-4" style={{ textAlign: $.strings.dir === 'rtl' ? 'left' : 'right' }}>
                            {$.strings.printVacation.date + ": "}
                            {
                                this.state.dataObject.requestDate &&
                                <span style={{ borderBottom: '1px dashed black' }}>
                                    {this.state.dataObject.requestDate}
                                </span>
                            }
                            {
                                !this.state.dataObject.requestDate &&
                                <span style={{ borderBottom: '1px dashed black' }}>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{"/"}
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{"/"}
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            }
                        </div>

                    </div>
                    <br />
                    <br />

                    {/* خاص بالادارة */}
                    <div className="p-grid" style={{ border: '1px solid gray', fontSize: '16px', fontWeight: 'bold' }}>
                        <div className="p-col-12 p-xl-12 p-lg-12 p-md-12 p-sm-12" style={{ background: 'lightgray' }}>
                            {$.strings.printVacation.specialForAdministration}
                        </div>

                        {/* موافق */}
                        <div className="p-col-2 p-xl-2 p-lg-2 p-md-2 p-sm-2">
                            <Checkbox id="lblAccept" caption={$.strings.printVacation.accept} checked={false} />
                        </div>

                        {/* غير موافق */}
                        <div className="p-col-2 p-xl-2 p-lg-2 p-md-2 p-sm-2">
                            <Checkbox InputId="lblReject" caption={$.strings.printVacation.reject} checked={false} />
                        </div>
                        <div className="p-col-8 p-xl-8 p-lg-8 p-md-8 p-sm-8">
                            <br />
                            ----------------------------------------------------------------------
                        </div>

                        {/* ملاحظات مدير الدائرة / رئيس القسم */}
                        <div className="p-col-4 p-xl-4 p-lg-4 p-md-4 p-sm-4">
                            {$.strings.printVacation.managerNotes}
                        </div>
                        <div className="p-col-8 p-xl-8 p-lg-8 p-md-8 p-sm-8">
                            ----------------------------------------------------------------------
                        </div>

                        <div className="p-col-12 p-xl-12 p-lg-12 p-md-12 p-sm-12">
                            <hr />
                        </div>

                        {/* توقيع مدير الدائرة / رئيس القسم */}
                        <div className="p-col-4 p-xl-4 p-lg-4 p-md-4 p-sm-4">
                            {$.strings.printVacation.managerSign}
                        </div>
                        <div className="p-col-4 p-xl-4 p-lg-4 p-md-4 p-sm-4">
                            --------------------------------
                        </div>

                        {/* التاريخ */}
                        <div className="p-col-4 p-xl-4 p-lg-4 p-md-4 p-sm-4" style={{ textAlign: $.strings.dir === 'rtl' ? 'left' : 'right', fontSize: '16px', fontWeight: 'bold' }}>
                            {$.strings.printVacation.date + ": "}
                            <span style={{ borderBottom: '1px dashed black' }}>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{"/"}
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{"/"}
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span>
                        </div>
                    </div>
                    <br />
                    <br />

                    {/* المتابعة */}
                    <div className="p-grid" style={{ border: '1px solid gray', fontSize: '16px', fontWeight: 'bold' }}>
                        <div className="p-col-12 p-xl-12 p-lg-12 p-md-12 p-sm-12" style={{ background: 'lightgray' }}>
                            {$.strings.printVacation.followUp}
                        </div>

                        {/* تم دوام */}
                        <div className="p-col-1 p-xl-1 p-lg-1 p-md-1 p-sm-1">
                            <Checkbox id="lblAccept" caption={""} checked={false} />
                        </div>
                        <div className="p-col-11 p-xl-11 p-lg-11 p-md-11 p-sm-11" >
                            <div style={{ display: 'flex' }}>
                                <span style={{ fontWeight: 'bold' }}>{$.strings.printVacation.workDone}</span>
                                &nbsp; &nbsp;
                                <table style={{ border: '1px solid black', borderCollapse: 'collapse', textAlign: 'center' }}>
                                    <tr>
                                        <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{$.strings.printVacation.minutes}</td>
                                        <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{$.strings.printVacation.hours}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </td>
                                        <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </td>
                                    </tr>
                                </table>
                                &nbsp; &nbsp;
                                <span style={{ fontWeight: 'bold' }}>{$.strings.printVacation.actualWorkNote}</span>
                                &nbsp; &nbsp;
                                <span>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{"/"}
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{"/"}
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            </div>
                        </div>
                        <div className="p-col-12 p-xl-12 p-lg-12 p-md-12 p-sm-12" style={{ marginInlineStart: '5px' }}>
                            <span style={{ fontSize: '16px', fontWeight: 'bold' }}>{$.strings.printVacation.actualWorkNoteText}</span>
                        </div>

                        <div className="p-col-4 p-xl-4 p-lg-4 p-md-4 p-sm-4" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                            {$.strings.printVacation.hrSign + ": "}
                        </div>
                        <div className="p-col-4 p-xl-4 p-lg-4 p-md-4 p-sm-4">
                            --------------------------------
                        </div>
                        <div className="p-col-4 p-xl-4 p-lg-4 p-md-4 p-sm-4" style={{ textAlign: $.strings.dir === 'rtl' ? 'left' : 'right', fontSize: '16px', fontWeight: 'bold' }}>
                            {$.strings.printVacation.date + ": "}
                            <span style={{ borderBottom: '1px dashed black' }}>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{"/"}
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{"/"}
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span>
                        </div>
                    </div>
                </div>
            ) :
            (
                <div id="divMain" style={{ direction: $.strings.dir, padding: '2em' }}>
                    {$.strings.operationFailed}
                </div>
            )
    }

    doPrint = () => {
        setTimeout(() => {
            window.print();
        }, 10);
        window.onafterprint = this.onafterprint;

    }
    onafterprint = () => {
        window.close();
    }

    getData = async () => {
        let dataObject = undefined;
        const params = {
            id: this.props.match.params.id
        }

        let res = await http.getJsonAxios(http.actions.HolidaysReq.urlGetPrintRequest, params, 0);

        if (res.status === 200) {
            if (res.data && res.data.success) {
                dataObject = res.data.data;
            }
        }
        return dataObject;
    }
    //urlGetPrintRequest
}